export default __webpack_public_path__ + "static/media/CNo.45-1.2fba6b0d.jpg";